import React from 'react'
import { connect } from 'react-redux'
import {
  Form,
  reduxForm,
  getFormValues,
  formValueSelector,
  change
} from 'redux-form'
import { useHistory } from 'react-router-dom'
import StyledSVG from '../components/shared/StyledSVG'
import pickupIcon from '../assets/icons/pickup-icon.svg'
import Button from '../components/button/Button'
import { makeStyles } from '@material-ui/core'
import SearchPickupQueueForm from '../components/form/SearchPickupQueueForm'
import {
  getPickupQueue,
  clearPickupQueues
} from './../store/pickup_queue/actions'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '64px 32px',
    fontFamily: 'Montserrat, Source Sans Pro',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: '100%',
    width: '96%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 8,
      '& path': {
        stroke: '#386093'
      },
      '& h1': {
        margin: 0,
        fontSize: 32,
        fontWeight: 700,
        color: '#386093'
      }
    }
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 144
  }
}))

const TitleComponent = ({ todayQueues }) => {
  if (todayQueues) {
    return <h1>Total de saídas de hoje</h1>
  }
  return <h1>Histórico de saídas</h1>
}
const SubtitleComponene = ({ todayQueues }) => {
  if (todayQueues) {
    return (
      <p className='subtitle'>
        Veja todas as retiradas realizadas no dia, com detalhes de horário,
        responsável e status de segurança.
      </p>
    )
  }
  return (
    <p className='subtitle'>
      Acompanhe todas as retiradas realizadas na escola e gere relatórios de
      segurança e presença.
    </p>
  )
}

const PickupHistoryPage = ({
  componentAttribute,
  handleSubmit,
  onSubmit,
  schoolId,
  change,
  getPickupQueue,
  clearPickupQueues,
  queues,
  gradeValue,
  classroomValue,
  relationshipValue,
  pickupDateValue,
  fieldValues,
  nameValue,
  touch
}) => {
  const classes = useStyles()
  const history = useHistory()
  const todayQueues = componentAttribute?.today
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className='title'>
          <StyledSVG height={28} width={28} src={pickupIcon} />
          <TitleComponent todayQueues={todayQueues} />
        </div>
        <Button
          type='button'
          onclick={() => history.goBack()}
          className={classes.go_back_btn}
        >
          Voltar
        </Button>
      </div>
      <SubtitleComponene todayQueues={todayQueues} />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <SearchPickupQueueForm
          getPickupQueue={getPickupQueue}
          clearPickupQueues={clearPickupQueues}
          queues={queues}
          schoolId={schoolId}
          change={change}
          gradeValue={gradeValue}
          classroomValue={classroomValue}
          relationshipValue={relationshipValue}
          pickupDateValue={pickupDateValue}
          nameValue={nameValue}
          touch={touch}
          todayQueues={todayQueues}
        />
      </Form>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('searchPickupQueueForm')
  return {
    fieldValues: getFormValues('searchPickupQueueForm')(state),
    schoolId: state.school?.currentSchool?.school_id,
    gradeValue: selector(state, 'grade_id'),
    classroomValue: selector(state, 'classroom_id'),
    relationshipValue: selector(state, 'relationship_type'),
    pickupDateValue: selector(state, 'pickup_date'),
    nameValue: selector(state, 'name'),
    queues: state.pickup_queues
  }
}

const mapDispatchToProps = dispatch => ({
  getPickupQueue: data => dispatch(getPickupQueue(data)),
  clearPickupQueues: () => dispatch(clearPickupQueues()),
  change: (field, data) =>
    dispatch(change('searchPickupQueueForm', field, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'searchPickupQueueForm',
    onSubmit: async (values, dispatch, props) => {}
  })(PickupHistoryPage)
)
